// DS: i12.2
import React, { useId } from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioDiscount: React.FC<Props> = props => {
  const clipPathId = useId();
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <g fill="currentColor" clipPath={`url(#${clipPathId})`}>
          <path d="M7.5 6.07a1.23 1.23 0 1 1-2.47 0 1.23 1.23 0 0 1 2.47 0m3.19.34A.79.79 0 0 0 9.57 5.3L5.3 9.57a.79.79 0 0 0 1.1 1.13l4.3-4.3Zm-.86 4.46a1.23 1.23 0 1 0 0-2.47 1.23 1.23 0 0 0 0 2.47"></path>
          <path
            fillRule="evenodd"
            d="M8 .75a2.4 2.4 0 0 0-1.7.7l-.5.5a.73.73 0 0 1-.51.22h-.72a2.4 2.4 0 0 0-2.4 2.4v.72c0 .19-.08.37-.22.5l-.5.5a2.4 2.4 0 0 0 0 3.42l.5.5c.14.13.22.31.22.5v.72a2.4 2.4 0 0 0 2.4 2.4h.71c.2 0 .38.08.52.22l.5.49a2.4 2.4 0 0 0 3.4 0l.5-.5a.73.73 0 0 1 .52-.2h.7a2.4 2.4 0 0 0 2.41-2.41v-.71c0-.2.08-.38.22-.52l.49-.5a2.4 2.4 0 0 0 0-3.4l-.5-.5a.73.73 0 0 1-.2-.52v-.7a2.4 2.4 0 0 0-2.41-2.41h-.72a.73.73 0 0 1-.5-.22l-.5-.5A2.4 2.4 0 0 0 8 .76Zm-.28 1.73a.73.73 0 0 1 .8.16l.5.5c.45.45 1.06.7 1.7.7h.7a.73.73 0 0 1 .74.73v.72c0 .63.25 1.24.7 1.7l.5.5a.73.73 0 0 1 0 1.03l-.5.5a2.4 2.4 0 0 0-.7 1.7v.7a.73.73 0 0 1-.73.74h-.72a2.4 2.4 0 0 0-1.7.7l-.5.5a.73.73 0 0 1-1.03 0l-.5-.5a2.4 2.4 0 0 0-1.7-.7h-.7a.73.73 0 0 1-.74-.73v-.72a2.4 2.4 0 0 0-.7-1.7l-.5-.5a.73.73 0 0 1 0-1.03l.5-.5c.45-.45.7-1.06.7-1.7v-.7a.73.73 0 0 1 .73-.74h.72a2.4 2.4 0 0 0 1.7-.7l.5-.5a.7.7 0 0 1 .23-.16"
            clipRule="evenodd"
          ></path>
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <path fill="#fff" d="M0 0h16v16H0z"></path>
          </clipPath>
        </defs>
      </svg>
    </IconWrap>
  );
};
StudioDiscount.displayName = 'StudioDiscount';

export default StudioDiscount;
